import TodoList from "./todolist/TodoList";
import "./Todo.css";
function Todo() {
  return (
    <div id="todo-view">
      <TodoList />
    </div>
  );
}

export default Todo;
